<template>
  <BittsLayout :is-page="true" layout-classes="overflow-y-auto">
    <template #content>
      <PageTitle title="API Keys" />
      <ApiKeysContent />
    </template>
  </BittsLayout>
</template>

<script lang="ts" setup>
import { BittsLayout } from '@crossbeam/bitts';

import { useHead } from '@unhead/vue';

import ApiKeysContent from '@/components/ApiKeysContent.vue';
import PageTitle from '@/components/PageTitle.vue';

useHead({ title: 'API Keys - Crossbeam' });
</script>
